import { stringAvatar } from "@/shared/utils/formattingFunctions";

export const getUserAvatar = (fullName: string | null | undefined): string | null => {
  if (fullName) {
    return stringAvatar(fullName);
  }
  return null;
};
